<template>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button class="button_back" @click="goBack">
          <ion-icon name="arrow-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-buttons slot="end">
        <ion-button
          class="button_more"
          @click="moreBottomDropUp = true"
          data-testid="button-more"
          v-if="userRole !== 'pharmacy'"
        >
          <ion-icon name="ellipsis-vertical-outline"></ion-icon>
        </ion-button>
        <ion-button @click="share()" v-else>
          <i class="el-icon-share"></i>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  
    <div class="main_wrapper ion-padding">
      <div class="container">
        <JobDetails
          :job="cleanReactiveObject(job)"
          :userRole="userRole"
          :isAustralia="isAustralia"
        />

        <div class="info-separator mt-0"></div>

        <el-form
        class="job_shifts_wrapper"
        :model="formsData.dayForm"
        :rules="formsData.dayForm.rules"
        :ref="(el) => (formsData.dayForm.ref = el)"
        :label-position="'top'"
        @submit.prevent="submit('dayForm')"
      >
        <el-form-item prop="jobShifts" class="job_shifts_form_checkbox">
          <!-- Initial skeleton loaders (only shown when no shifts are loaded yet) -->
          <template v-if="isLoadingShifts && shiftsList.length === 0">
            <shift-card-skeleton v-for="n in 3" :key="`skeleton-${n}`" />
          </template>
          
          <template v-if="shiftsList && shiftsList.length > 0">
            <ShiftCard
              v-for="(shift, i) in shiftsList"
              :key="`shift-${shift.id}`"
              :shift="shift"
              :i="i"
              :job="cleanReactiveObject(job)"
              :userRole="userRole"
              :isBlockShift="isBlockShift"
              :isAustralia="isAustralia"
              :showActions="showActions"
              :bottomDropUp="bottomDropUp"
              :activeCollapse="activeCollapse"
              :handleClick="handleClick"
              :goToJobCalendar="goToJobCalendar"
              :travelCompensationCount="travelCompensationCount"
              :formatCurrency="formatCurrency"
              :isSelected="isSelected"
              :handleCheckboxChange="handleCheckboxChange"
              :goToJobApplicants="goToJobApplicants"
              :actions="actions"
              @update-bottom-drop-up="(index, value) => (bottomDropUp[index] = value)"
              @update-active-collapse="(value) => (activeCollapse = value)"
              @update-show-actions="(index, value) => (showActions[index] = value)"
            />
            <!-- Skeleton loaders for pagination (shown below shifts when loading more) -->
            <template v-if="isLoadingMoreShifts">
              <shift-card-skeleton v-for="n in 2" :key="`skeleton-more-${n}`" />
            </template>
            <div
              v-if="hasMoreShifts && shiftsList.length > 0"
              v-infinite-scroll="loadMoreShifts"
              :infinite-scroll-disabled="isLoadingShifts || isLoadingMoreShifts || !hasMoreShifts"
              :infinite-scroll-distance="120"
              class="shifts-load-more-sentinel"
            ></div>
          </template>
        </el-form-item>
        <el-form-item class="button_submit m-0 fixed-bottom-buttons">
          <template v-if="selectedApplicants.length === 0">
            <div class="d-flex">
              <el-button class="submit_page flex-1" type="grey" @click="goNext('dayForm')">
                Calendar View
              </el-button>
              <el-button
                v-if="
                  shifts.length > 0 && shifts[0].applicationSelected == false && isBlockShift === 1 && shifts[0].shiftApplicationType !== 0
                "
                class="submit_page flex-1"
                type="blue"
                @click="actions.bulkViewApplicants(job)"
              >
                View Applications
              </el-button>
            </div>
          </template>
          <template
            v-else-if="isBlockShift === 0 && selectedApplicants.length !== 0"
          >
            <div class="offer-button-group">
              <el-button
                class="submit_page flex-1 primary"
                @click="actions.shiftOffer(job)"
              >
                Offer
              </el-button>
              <el-button
                class="submit_page flex-1 danger"
                @click="actions.bulkDecline(job)"
              >
                Decline
              </el-button>
            </div>
          </template>

          <el-button
            v-if="routeName == 'job_book_days'"
            class="submit_page"
            type="blue"
            @click="submit('dayForm')"
            :disabled="formsData.dayForm.disabled"
          >
            Accept
          </el-button>
        </el-form-item>
      </el-form>
      </div>
  
      <div class="bg-overlay"></div>
    </div>
    <el-drawer
      custom-class="bottom_drop_up"
      v-model="moreBottomDropUp"
      :append-to-body="true"
      :with-header="false"
      :direction="'btt'"
      :destroy-on-close="true"
      data-testid="more-bottom-drop-up-drawer"
    >
      <div>
        <el-button
          class="d-block"
          @click="share(user)"
          data-testid="share-pharmacy-btn"
        >
          <i class="el-icon-share"></i> Share
        </el-button>
        <el-button
          class="ml-0 d-block"
          @click="blockPharmacy()"
          data-testid="block-unblock-pharmacy-btn"
        >
          <template v-if="job.blockedByLocum">
            <i class="el-icon-unlock mr-1 font-weight-bold"></i> Unblock Pharmacy
          </template>
          <template v-else>
            <i class="locumate_icons locumate_icon-denied mr-1"></i> Block
            Pharmacy
          </template>
        </el-button>
      </div>
    </el-drawer>
    <el-dialog
      modal-class="remove-shift-modal"
      v-if="dialog.dialogVisible"
      v-model="dialog.dialogVisible"
      :destroy-on-close="true"
      @close="actions.closeDialog"
      :title="`Shift for ${$moment(dialog.data.shift.date, 'YYYY/MM/DD').format(
        isAustralia ? 'dddd, D MMMM' : 'dddd, MMM D YYYY'
      )}`"
    >
      <div class="dialog-wrapper">
        <div
          class="cancel-message"
          v-if="bulkShiftListToShow.hasOwnProperty('shifts')"
        >
          Please note that this is a bulk shift. If you cancel this shift, all
          other shifts in the same job will also be removed. Following are the
          shifts that will be cancelled.
          <ul>
            <li v-for="shift in bulkShiftListToShow.shifts" :key="shift.id">
              {{ formatDate(shift.date) }} | {{ shift.startTime }} -
              {{ shift.endTime }}
            </li>
          </ul>
        </div>
        <span class="d-flex mb-1">Please choose your cancellation reason:</span>
        <div class="dialog-element">
          <el-select
            popper-class="normal-select"
            v-model="dialog.cancel.reasonType"
            placeholder="Choose an option"
          >
            <el-option
              v-for="item in dialog.cancel.options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
  
        <div class="dialog-element" v-if="dialog.cancel.reasonType === 3">
          <el-input
            maxlength="255"
            show-word-limit
            v-model="dialog.cancel.description"
            :rows="4"
            type="textarea"
            placeholder="Please describe your situation"
          />
        </div>
        <div class="buttons-group">
          <button class="button" @click="actions.closeDialog">Cancel</button>
          <button
            class="button red"
            :disabled="removeButtonDisabled"
            @click="
              actions.removeShift(
                dialog.data.job,
                dialog.data.shift,
                dialog.data.i
              )
            "
          >
            Remove
          </button>
        </div>
      </div>
    </el-dialog>
    <modal-user-info
      :modalName="'userInfoModal'"
      :options="userInfoModal"
    ></modal-user-info>
    <modal-shift-edit
      v-if="userRole === 'pharmacy'"
      :modalName="'shiftEditModal'"
      :options="shiftEditModal"
    ></modal-shift-edit>
    <modal-applicants-view
      v-if="userRole === 'pharmacy'"
      :modalName="'ApplicationsModal'"
      :options="ApplicationsModal"
    ></modal-applicants-view>
    <modal-block-applicants-info
      v-if="userRole === 'pharmacy'"
      :modalName="'BlockApplicationsModal'"
      :options="BlockApplicationsModal"
    ></modal-block-applicants-info>
    <modal-agency-info
      :modalName="'agencyInfoModal'"
      :options="agencyInfoModal"
    ></modal-agency-info>
    <modal-block-shift-info      
      :modalName="'BlockShiftModal'"
      :options="BlockShiftModal"
    ></modal-block-shift-info>
  </template>
  
  <script>
  import { ElMessage, ElMessageBox } from "@/components/Vendor/Element";
  
  import moment from "moment";
  
  import { ref, onMounted, inject, computed, watch, nextTick } from "vue";
import { cleanReactiveObject } from "@/helpers/utility/vueUtils";
  
  import { addIcons } from "ionicons";
  import { arrowBackOutline, ellipsisVerticalOutline } from "ionicons/icons";
  
  addIcons({
    "arrow-back-outline": arrowBackOutline,
    "ellipsis-vertical-outline": ellipsisVerticalOutline,
  });
  import {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    // IonTitle,
  } from "@ionic/vue";
  
  import { useStore } from "vuex";
  import { useRouter, useRoute } from "vue-router";
  import formHooks from "@/hooks/form/form";
  import formValidate from "@/hooks/form/validate/validate";
  
  const currentUrl = process.env.VUE_APP_CURRENT_URL;
  import {
    UserInfoModal,
    ShiftEditModal,
    ApplicationsModal,
    BlockApplicationsModal,
    AgencyInfoModal,
    BlockShiftModal,
  } from "@/modals/modals";
  import ShiftCard from "../Components/ShiftCard.vue";
  import ShiftCardSkeleton from "../Shifts/Book/Days/components/ShiftCardSkeleton.vue";
  import JobDetails from "../Components/JobDetails.vue";
  import { vTouch } from "vue3-touch-events";
  import { isAustraliaRegion } from "@/helpers/region/regionHelper.js";
  import distanceInMiles from "@/helpers/distance/distance-in-miles.js";
  
  
  export default {
    components: {
      IonToolbar,
      IonButton,
      IonButtons,
      IonIcon,
      "modal-user-info": UserInfoModal,
      "modal-shift-edit": ShiftEditModal,
      "modal-applicants-view": ApplicationsModal,
      "modal-agency-info": AgencyInfoModal,
      "modal-block-applicants-info": BlockApplicationsModal,
      "modal-block-shift-info": BlockShiftModal,
      ShiftCard,
      ShiftCardSkeleton,
      JobDetails,
    },
    setup() {
      const $store = useStore();
      const $router = useRouter();
      const $route = useRoute();
      const $moment = inject(["$moment"]);
      const setPageClassGlobal = inject("setPageClassGlobal");
      const $modals = inject("$modals");
      const message = inject("messages");
      const routeName = $route.name;
      const moreBottomDropUp = ref(false);
      const userData = $store.getters.GET_USER_DATA;
      const userRole = userData.role;
      const selectedApplicants = ref([]);
      const showActions = ref([]);
      const isAustralia = isAustraliaRegion();
      const bulkShiftListToShow = ref({});
  
      let job = ref($store.getters.getJobDetails.job);

      // Pagination state for shifts
      const shifts = ref([]);
      const currentPage = ref(1);
      const isLoadingShifts = ref(false);
      const isLoadingMoreShifts = ref(false);
      const shiftsMeta = ref(null);
      const hasMoreShifts = ref(true);

      // Computed property to ensure reactivity in template
      const shiftsList = computed(() => {
        return Array.isArray(shifts.value) ? shifts.value : [];
      });

      let isBlockShift = computed(() => job.value.isBlockShift);

      const bottomDropUp = ref([]);

      // Initialize bottomDropUp for existing shifts
      const initializeBottomDropUp = () => {
        // Preserve the currently open drawer state by shift ID
        let openShiftId = null;
        if (Array.isArray(shifts.value) && Array.isArray(bottomDropUp.value)) {
          shifts.value.forEach((shift, i) => {
            if (bottomDropUp.value[i] === true && shift?.id) {
              openShiftId = shift.id;
            }
          });
        }
        
        // Reset array but preserve state if appending shifts
        if (Array.isArray(shifts.value)) {
          const newBottomDropUp = [];
          shifts.value.forEach((shift, i) => {
            // Restore drawer state if this is the shift that was open
            newBottomDropUp[i] = (shift?.id === openShiftId);
          });
          bottomDropUp.value = newBottomDropUp;
        } else {
          bottomDropUp.value = [];
        }
      };

      // Reset shifts pagination
      const resetShifts = () => {
        shifts.value = [];
        currentPage.value = 1;
        hasMoreShifts.value = true;
        shiftsMeta.value = null;
        isLoadingShifts.value = false;
        isLoadingMoreShifts.value = false;
      };

      // Fetch shifts with pagination
      const fetchShifts = async (page = 1, append = false) => {
        if (isLoadingShifts.value || isLoadingMoreShifts.value || (!hasMoreShifts.value && page > 1)) return;
        if (!job.value || !job.value.id) {
          console.warn("Cannot fetch shifts: job or job.id is missing", job.value);
          return;
        }
        
        // Use isLoadingShifts only for the first page, isLoadingMoreShifts for subsequent pages
        if (page === 1) {
          isLoadingShifts.value = true;
        } else {
          isLoadingMoreShifts.value = true;
        }
        try {
          const response = await $store.dispatch("GET_JOB_SHIFTS_LIST", {
            jobId: job.value.id,
            params: {
              page: page,
              with: "abilities",
              navigation: "pharmacy_shift_details_page",
              per_page: 10, // Adjust per page as needed
              hideLoading: page > 1,
            },
          });

          // Handle different response structures
          let shiftsData = null;
          let metaData = null;

          if (response) {
            // Check if response has data property (paginated response)
            if (response.data && Array.isArray(response.data)) {
              shiftsData = response.data;
              metaData = response.meta || null;
            } 
            else {
              console.warn("Unknown response structure:", response);
            }
          }

          if (shiftsData && Array.isArray(shiftsData)) {
            // Convert reactive objects to plain objects to avoid _isVue warnings
            // This recursively cleans all nested objects as well
            const plainShifts = shiftsData.map(shift => {
              return cleanReactiveObject(shift);
            });
            
            if (append) {
              const currentShifts = Array.isArray(shifts.value) ? shifts.value : [];
              shifts.value = [...currentShifts, ...plainShifts];
            } else {
              // Clear and assign new array to ensure reactivity
              shifts.value.splice(0, shifts.value.length, ...plainShifts);
            }

            shiftsMeta.value = metaData;
            if (metaData && metaData.lastPage) {
              hasMoreShifts.value = page < metaData.lastPage;
            } else {
              // If no meta, assume no more pages if we got less than per_page
              hasMoreShifts.value = shiftsData.length >= 10;
            }
            
            // Force reactivity update
            nextTick(() => {
              console.log("After nextTick - shifts count:", shifts.value.length);
              console.log("Template should render", shifts.value.length, "shifts");
            });
            
            // Initialize bottomDropUp for new shifts
            initializeBottomDropUp();
            
            // Set isLoadingShifts to false after first page loads so shifts are visible
            if (page === 1) {
              isLoadingShifts.value = false;
            }

            // Further pages load via infinite scroll (loadMoreShifts) — same data, deferred.
            if (!hasMoreShifts.value) {
              isLoadingMoreShifts.value = false;
            }
          } else {
            console.warn("No valid shifts data in response:", response);
            // Ensure shifts is always an array even if response is invalid
            shifts.value = [];
          }
        } catch (error) {
          console.error("Error fetching shifts:", error);
          shifts.value = [];
        } finally {
          // Ensure loading states are cleared
          if (page === 1) {
            isLoadingShifts.value = false;
          } else {
            isLoadingMoreShifts.value = false;
          }
        }
      };

      // Setup watch for job changes AFTER fetchShifts is defined
      watch(
        () => $store.getters.getJobDetails.job,
        (newJob) => {
          job.value = newJob;
          // Reset shifts when job changes
          if (newJob && newJob.id) {
            resetShifts();
            fetchShifts();
          } else {
            console.warn("Job changed but no valid job.id:", newJob);
          }
        },
        { immediate: true } // Run immediately to fetch shifts if job is already available
      );

      // Load more shifts
      const loadMoreShifts = () => {
        if (!isLoadingShifts.value && hasMoreShifts.value) {
          currentPage.value += 1;
          fetchShifts(currentPage.value, true);
        }
      };

      const newJobData = computed(() => {
        return $store.getters.refreshJobData;
      });
  
      const activeCollapse = ref(""); // Holds the currently open collapse item's name
   
      const isSelected = (applicantId) => {
        return selectedApplicants.value.includes(applicantId);
      };
  
      const handleCheckboxChange = (applicantId) => {
        const index = selectedApplicants.value.indexOf(applicantId);
        if (index === -1) {
          selectedApplicants.value.push(applicantId);
        } else {
          selectedApplicants.value.splice(index, 1);
        }
      };
      // Check if selectedApplicants contains at most one shift application id for each shift
      const isValidSelect = () => {
        var shiftsAssigned = [];
        shifts.value.forEach((jobShift) => {
          var shiftId = jobShift.id;
          var shiftApplicationIds = jobShift.shiftApplications.map(
            (applicant) => {
              return applicant.id;
            }
          );
  
          var shiftApp = selectedApplicants.value.filter((shiftApplicantId) => {
            return shiftApplicationIds.includes(shiftApplicantId);
          });
          shiftsAssigned.push({ id: shiftId, shiftassigned: shiftApp.length });
        });
        return shiftsAssigned;
      };
  
      const goToJobApplicants = (shiftId) => {
        $router.push({
          name: "shift_applicants",
          params: {
            shiftId: shiftId,
          },
        });
      };
  
      const formsDataArray = {
        dayForm: {
          jobShifts: {
            value: computed(() => Array.isArray(shifts.value) ? shifts.value : []),
            validators: [
              {
                validator: (rule, formField, callback) => {
                  formValidate.validate(
                    rule,
                    formField,
                    "jobShiftsBook",
                    callback,
                    setFormValidation
                  );
                },
              },
            ],
          },
        },
      };
  
      const checkJobDateStart = (dateStart, endDate, trim) => {
        let start = moment(dateStart, "YYYY/MM/DD");
        let end = moment(endDate, "YYYY/MM/DD");
        if (start.format("MMMM") == end.format("MMMM")) {
          if (start.format("D") == end.format("D")) {
            return start.format("D " + (trim ? "MMM" : "MMMM"));
          }
          return (
            start.format("D ") +
            " - " +
            end.format("D " + (trim ? "MMM" : "MMMM"))
          );
        } else {
          return (
            start.format("D " + (trim ? "MMM" : "MMMM")) +
            " - " +
            end.format("D " + (trim ? "MMM" : "MMMM"))
          );
        }
      };
  
      const getSelectedShiftsId = () => {
        return shifts.value
          .filter((day) => {
            if (day.checkboxValue == true) {
              return true;
            }
          })
          .map((day) => day.id);
      };
  
      const featureShiftsMarkArray = ref([]);
      const pastShiftsMark = ref(false);
  
      const breakTimeFormat = (shift) => {
        let shiftBreakTime = shift.userBreakMinutes;
        if (Math.floor(shiftBreakTime / 60)) {
          return moment(
            Math.floor(shiftBreakTime / 60) + ":" + (shiftBreakTime % 60),
            ["h:m"]
          ).format("H:mm");
        } else {
          return moment(shiftBreakTime % 60, ["m"]).format("m");
        }
      };
      const formatHourlyRate = (regularRate, weekendRate) => {
        if (
          job.value.shifts.length === 1 &&
          job.value.shifts[0].payRateExecSuper
        ) {
          return new Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: "AUD",
          }).format(
            job.value.shifts[0].payRate - job.value.shifts[0].payRateSuper
          );
        }
        let formattedString = "";
        formattedString += regularRate ? formatCurrency(regularRate) : "";
        formattedString += regularRate && weekendRate ? " - " : "";
        formattedString += weekendRate ? formatCurrency(weekendRate) : "";
  
        return formattedString;
      };
  
      const formatCurrency = (rate) => {
        return new Intl.NumberFormat("en-AU", {
          style: "currency",
          currency: "AUD",
        }).format(rate);
      };
  
      const bottomDropUpClose = (i) => {
        bottomDropUp.value[i] = false;
      };
  
      const shiftEditModal = ref({
        name: "shiftEdit",
        job: {},
        shift: {},
      });
  
      const ApplicationsModal = ref({
        name: "viewApplicants",
        job: {},
        shift: {},
      });
  
      const BlockApplicationsModal = ref({
        name: "bulkViewApplicants",
        job: {},
      });
  
      const BlockShiftModal = ref({
        name: "bulkViewShifts",
        job: {},
      });
  
      const shiftEditModalOpen = (job, shift) => {
        shiftEditModal.value.job = job;
        shiftEditModal.value.shift = shift;
        $modals.open("shiftEditModal");
      };
  
      const applicantViewModalOpen = (job, shift) => {
        ApplicationsModal.value.job = job;
        ApplicationsModal.value.shift = shift;
        $modals.open("ApplicationsModal");
      };
      const blockApplicantViewModalOpen = (jobArg) => {
        // Optimized jobs-detail omits embedded shifts; applicants live on the paginated list.
        const loadedShifts = Array.isArray(shifts.value) ? shifts.value : [];
        BlockApplicationsModal.value.job = {
          ...(jobArg || {}),
          shifts: loadedShifts.length
            ? loadedShifts
            : (Array.isArray(jobArg?.shifts) ? jobArg.shifts : []),
        };
        $modals.open("BlockApplicationsModal");
      };
      const blockShiftViewModalOpen = async (job, shift, i) => {
        console.log("≡ƒÜÇ ~ blockShiftViewModalOpen ~ shift:", shift)
        console.log("≡ƒÜÇ ~ blockShiftViewModalOpen ~ job:", job)
        
        // For block shifts, fetch all shifts before opening modal
        if (job?.isBlockShift == 1) {
          try {
            const response = await $store.dispatch("GET_BLOCK_SHIFT_SHIFTS", {
              shiftId: shift.id,
              params: {
                with: "settings",
              },
            });
            
            // The response.data contains the job with all shifts
            BlockShiftModal.value.job = response.data;
            BlockShiftModal.value.selectedShift = shift;
            BlockShiftModal.value.i = i;
          } catch (error) {
            console.error("Error fetching block shift shifts:", error);
            // Fallback to original job if fetch fails
            BlockShiftModal.value.job = job;
            BlockShiftModal.value.selectedShift = shift;
            BlockShiftModal.value.i = i;
          }
        } else {
          // For non-block shifts, use the job as is
          BlockShiftModal.value.job = job;
          BlockShiftModal.value.selectedShift = shift;
          BlockShiftModal.value.i = i;
        }
        
        $modals.open("BlockShiftModal");
      };
  
      const dialog = ref({
        dialogVisible: false,
        data: {},
        cancel: {
          reasonType: null,
          options: [
            { label: "Change in availability", value: 1 },
            { label: "Other...", value: 3 },
          ],
          description: null,
        },
      });
      const getCancellationReason = () => {
        if (dialog.value.cancel.reasonType === 3) {
          return dialog.value.cancel.description;
        }
        return dialog.value.cancel.options[dialog.value.cancel.reasonType - 1]
          .label;
      };
  
      const removeButtonDisabled = computed(() => {
        if (
          dialog.value.cancel.reasonType &&
          dialog.value.cancel.reasonType !== 3
        )
          return false;
        if (
          dialog.value.cancel.reasonType === 3 &&
          dialog.value.cancel.description
        )
          return false;
        return true;
      });
  
      const actions = {
        editShift(job, shift, i) {
          bottomDropUpClose(i);
          shiftEditModalOpen(job, shift);
        },
        viewApplicants(job, shift, i) {
          bottomDropUpClose(i);
          applicantViewModalOpen(job, shift);
        },
        bulkViewApplicants(job) {
          console.log("≡ƒÜÇ ~ job:", job)
          blockApplicantViewModalOpen(job);
        },
        async bulkViewShifts(job, shift, i) {
          bottomDropUpClose(i);
          await blockShiftViewModalOpen(job, shift, i);
        },
        shiftOffer(job) {
          const isValidselectedApp =
            isValidSelect().filter((item) => item.shiftassigned > 1).length > 0;
  
          if (isValidselectedApp) {
            ElMessageBox.alert(
              "Multiple applicants have been assigned to a single shift. Please review and correct the assignment.",
              "Error",
              {
                showCancelButton: false,
                confirmButtonText: "Close",
                confirmButtonClass: "el-button--red",
              }
            );
          } else {
            (async () => {
              try {
                await ElMessageBox.confirm(
                  `Are you sure you'd like to offer shift(s) to selected applicant(s)?`,
                  "Offer Shift",
                  {
                    confirmButtonText: "Offer",
                    cancelButtonText: "Cancel",
                    confirmButtonClass: "el-button--blue",
                    cancelButtonClass: "secondary",
                    showClose: false,
                  }
                );
                await (async () => {
                  try {
                    await $store.dispatch("BULK_OFFER", {
                      application_ids: selectedApplicants.value,
                    });
  
                    const jobResponse = await $store.dispatch(
                      "GET_JOB_INFO_DETAILS",
                      {
                        jobId: job.id,
                        params: {
                          with: "pharmacy,pharmacy.settings,pharmacy.address,pharmacy.files,locum,locum.settings,locum.address,shifts.pharmacy,shifts.pharmacy.settings,shifts.pharmacy.address,shifts.pharmacy.files,shifts.locum,shifts.locum.settings,shifts.locum.address,abilities,config.hours_before_shift_lock,settings,agency,shifts.agency, shifts.shiftApplications",
                        },
                      }
                    );
  
                    $store.dispatch("clearJobDetails");
                    $store.dispatch("setJobDetails", {
                      job: jobResponse.data,
                    });
  
                    ElMessage({
                      type: "success",
                      message: "All Applicants offered successfully",
                    });
                    selectedApplicants.value = [];
                  } catch (error) {
                    ElMessage({
                      type: "info",
                      message: "All Applicants did not offered",
                    });
                    console.log("error submit!!", error);
                  }
                })();
              } catch (error) {
                console.log(error);
              }
            })();
          }
        },
        bulkDecline(job) {
          let startDate = checkJobDateStart(job.startDate, job.endDate, true);
          let popUpTitle = null;
          let content = null;
          if (selectedApplicants.value.length > 1) {
            popUpTitle = "Decline Bulk Applicants";
            content = `Are you sure youΓÇÖd like to decline bulk applicants for ${startDate} shift.`;
          } else {
            popUpTitle = "Decline Applicant";
            content = `Are you sure youΓÇÖd like to decline applicant for ${startDate} shift.`;
          }
          (async () => {
            try {
              await ElMessageBox.confirm(content, popUpTitle, {
                confirmButtonText: "Decline",
                cancelButtonText: "Cancel",
                confirmButtonClass: "danger",
                cancelButtonClass: "secondary",
                showClose: false,
              });
              await (async () => {
                try {
                  await $store.dispatch("BULK_DECLINE", {
                    application_ids: selectedApplicants.value,
                  });
  
                  const jobResponse = await $store.dispatch(
                    "GET_JOB_INFO_DETAILS",
                    {
                      jobId: job.id,
                      params: {
                        with: "pharmacy,pharmacy.settings,pharmacy.address,pharmacy.files,locum,locum.settings,locum.address,shifts.pharmacy,shifts.pharmacy.settings,shifts.pharmacy.address,shifts.pharmacy.files,shifts.locum,shifts.locum.settings,shifts.locum.address,abilities,config.hours_before_shift_lock,settings,agency,shifts.agency, shifts.shiftApplications",
                      },
                    }
                  );
  
                  $store.dispatch("clearJobDetails");
                  $store.dispatch("setJobDetails", {
                    job: jobResponse.data,
                  });
  
                  ElMessage({
                    type: "success",
                    message: "Applicant(s) has been declined",
                  });
                  selectedApplicants.value = [];
                } catch (error) {
                  ElMessage({
                    type: "info",
                    message: "All Applicants did not declined",
                  });
                  console.log("error submit!!", error);
                }
              })();
            } catch (error) {
              console.log(error);
            }
          })();
        },
        removeApplicants(job, shift, i) {
          bottomDropUpClose(i);
          (async () => {
            try {
              await ElMessageBox.confirm(
                `Are you sure youΓÇÖd like to remove ${
                  shift.applicationSelectedBy.locum.name
                } applicant for ${$moment(shift.date, "YYYY/MM/DD").format(
                  "D MMM, YYYY"
                )} shift.`,
                "Remove applicant",
                {
                  confirmButtonText: "Remove",
                  cancelButtonText: "Cancel",
                  confirmButtonClass: "el-button--red",
                  cancelButtonClass: "el-button--grey",
                  showClose: false,
                }
              );
              await (async () => {
                try {
                  await $store.dispatch("WITHDRAW_APPLICANT_BY_PHARMACY", {
                    application_id: shift.applicationSelectedBy.id,
                  });
  
                  const jobResponse = await $store.dispatch(
                    "GET_JOB_INFO_DETAILS",
                    {
                      jobId: job.id,
                      params: {
                        with: "pharmacy,pharmacy.settings,pharmacy.address,pharmacy.files,locum,locum.settings,locum.address,shifts.pharmacy,shifts.pharmacy.settings,shifts.pharmacy.address,shifts.pharmacy.files,shifts.locum,shifts.locum.settings,shifts.locum.address,abilities,config.hours_before_shift_lock,settings,agency,shifts.agency, shifts.shiftApplications",
                      },
                    }
                  );  
                  $store.dispatch("clearJobDetails");
                  $store.dispatch("setJobDetails", {
                    job: jobResponse.data,
                  });
  
                  ElMessage({
                    type: "success",
                    message: "Applicant removed successfully",
                  });
                } catch (error) {
                  ElMessage({
                    type: "info",
                    message: "Applicant did not removed",
                  });
                  console.log("error submit!!", error);
                }
              })();
              bottomDropUpClose(i);
            } catch (error) {
              console.log(error);
            }
          })();
        },
        async openDialog(job, shift, i) {
          if (job?.isBlockShift == 1) {
            let response = await $store.dispatch("GET_BLOCK_SHIFT_SHIFTS", {
              shiftId: shift.id,
              params: { 
                with: "settings",
              }
            });
  
            bulkShiftListToShow.value = response.data;
  
            
          }
          dialog.value.dialogVisible = true;
          dialog.value.data = { job, shift, i };
        },
        closeDialog() {
          dialog.value.dialogVisible = false;
          dialog.value.cancel.reasonType = null;
          dialog.value.cancel.description = null;
        },
        removeShift(job, shift, i) {
          (async () => {
            try {
              let formattedDates = null;
              if (job.isBlockShift == 1) {
                let response = await $store.dispatch("GET_BLOCK_SHIFT_SHIFTS", {
                  shiftId: shift.id,
                });
  
                formattedDates = response.data.shifts
                  .map((shift) =>
                    $moment(shift.date, "YYYY-MM-DD").format("D MMM YYYY")
                  )
                  .join(", ");
              }
  
              (async () => {
                try {
                  if (job.isBlockShift == 1) {
                    let alertMessageHtml = `Are you sure youΓÇÖd like to remove shifts for following ${formattedDates} dates?`;
                    if (bulkShiftListToShow.value.shifts.length > 1) {
                      alertMessageHtml = `<div class="cancel-message">
                    Please note that this is a bulk shift. If you cancel this shift, all other shifts in the same job will also be removed. Following are the shifts that will be cancelled.
                    <ul>`;
                      bulkShiftListToShow.value.shifts.forEach((shift) => {
                        alertMessageHtml += `<li>${formatDate(shift.date)} | ${
                          shift.startTime
                        } - ${shift.endTime}</li>`;
                      });
                      alertMessageHtml += `</ul></div>`;
                    }
                    await ElMessageBox.confirm(
                      // `Are you sure youΓÇÖd like to remove shifts for ${formattedDates}?`,
                      alertMessageHtml,
                      "Remove shift",
                      {
                        confirmButtonText: "Remove",
                        cancelButtonText: "Cancel",
                        confirmButtonClass: "el-button--red",
                        cancelButtonClass: "el-button--grey",
                        showClose: false,
                        dangerouslyUseHTMLString: true,
                        customClass: "remove-shift-confirm-modal",
                      }
                    );
                  } else {
                    await ElMessageBox.confirm(
                      `Are you sure youΓÇÖd like to remove shift for ${$moment(
                        shift.date,
                        "YYYY/MM/DD"
                      ).format("D MMM, YYYY")}`,
                      "Remove shift",
                      {
                        confirmButtonText: "Remove",
                        cancelButtonText: "Cancel",
                        confirmButtonClass: "el-button--red",
                        cancelButtonClass: "el-button--grey",
                        showClose: false,
                      }
                    );
                  }
                  const reason = getCancellationReason();
  
                  await (async () => {
                    try {
                      if (userRole == "locum") {
                        await $store.dispatch("EXIT_SHIFT", {
                          shiftId: shift.id,
                          reason: reason,
                        });
                        dialog.value.dialogVisible = false;
                      } else {
                        await $store.dispatch("DELETE_SHIFT", {
                          shiftId: shift.id,
                          reason: reason,
                        });
                      }
  
                      ElMessage({
                        type: "success",
                        message: "Shift removed successfully",
                      });
                      dialog.value.dialogVisible = false;
                      shifts.value.splice(i, 1);
  
                      if (
                        (userRole == "pharmacy" && shifts.value.length == 0) ||
                        (userRole == "pharmacy" && job.isBlockShift == 1)
                      ) {
                        $router.push({
                          name: "search",
                        });
                      }
                    } catch (error) {
                      console.log("≡ƒÜÇ ~ error:", error)
                      ElMessage({
                        type: "info",
                        message: "Shift did not removed",
                      });
                      console.log("error submit!!");
                    }
                  })();
                  bottomDropUpClose(i);
                } catch (error) {
                  console.log(error);
                }
              })();
            } catch (error) {
              console.log("error submit!!", error);
            }
          })();
        },
        goToGuestShiftDetails(shift, i) {
          bottomDropUpClose(i);
          $router.push({
            name: "guest_shift_details",
            params: {
              shiftId: shift.guestId,
            },
          });
        },
      };
  
      const userInfoModal = ref({
        name: "userInfo",
        user: {},
      });
  
      const agencyInfoModal = ref({
        name: "agencyInfo",
        user: {},
      });
  
      const isSlimUserPayload = (user) => {
        // Pharmacy shift-details optimisation returns id/name/image only (no role / docs).
        return !!(user && user.id && !user.role);
      };

      const userInfoModalOpen = async (user) => {
        if (user && user !== 'pharmacy') {
          if (isSlimUserPayload(user)) {
            try {
              const response = await $store.dispatch("GET_PROFILE_USER_INFO", {
                userId: user.id,
              });
              if (!response?.data) {
                return;
              }
              userInfoModal.value.user = response.data;
            } catch (error) {
              console.log("error loading locum profile", error);
              return;
            }
          } else {
            userInfoModal.value.user = user;
          }
        } else {
          userInfoModal.value.user = job.value.pharmacy;
        }
  
        $modals.open("userInfoModal");
      };
  
      const agnecyInfoModalOpen = (user) => {
        agencyInfoModal.value.user = user;
        $modals.open("agencyInfoModal");
      };
  
      const goToJobCalendar = (shift) => {
        $router.push({
          name: "job_calendar",
          params: {
            date: shift.date,
          },
        });
      };
  
      const goBack = () => {
        $router.push({
          name: $store.getters["getPageBack"]({
            state: "job",
            remove: true,
          }).name,
          params: {
            date: $store.getters.getJobDetails.date,
          },
        });
      };
  
      const goNext = () => {
        $store.dispatch("setJobDetails", {
          job: job.value,
        });
        $router.push({
          name: "job_calendar",
          params: {
            date: $route.params.date || null,
          },
        });
      };
  
      const submit = (formName) => {
        formsRefs[formName].value.validate((valid) => {
          if (valid) {
            (async () => {
              try {
                await $store.dispatch("SAVE_JOB_SHIFTS_LIST", {
                  shifts_ids: getSelectedShiftsId(),
                });
                ElMessage({
                  type: "success",
                  message: "Thank you for booking the shift.",
                });
                $router.push({
                  name: "search",
                });
              } catch (error) {
                console.log("error submit!!");
              }
            })();
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      };
  
      const handleClick = async (shift) => {

        if (userRole === "pharmacy") {
          if (shift.locum) {
            await userInfoModalOpen(shift.locum);
          } else if (shift.status === 14) {
            agnecyInfoModalOpen(shift.agency);
          } else {
            return false;
          }
        }
      };
  
      onMounted(() => {
        setPageClassGlobal("global_job_book_page");
        setFormRefs();
        checkFormValidation("dayForm", false);
        const touchEvents = vTouch({
          swipe: {
            threshold: 15, // Adjust the swipe threshold if needed
          },
        });
        touchEvents.install(); // Install the touch events
        
        // Try to fetch shifts if not already loaded (backup in case watch didn't trigger)
        nextTick(() => {
          if (job.value && job.value.id && shifts.value.length === 0 && !isLoadingShifts.value) {
            fetchShifts();
          }
        });
        

        // Process shifts for marking
        watch(shifts, () => {
          let featureShiftsMarkLocal = false;
          shifts.value.forEach((shift) => {
            if (
              !moment(shift.date, "YYYY-MM-DD").isBefore(new Date(), "day") &&
              !featureShiftsMarkLocal
            ) {
              featureShiftsMarkLocal = true;
              featureShiftsMarkArray.value.push(true);
            } else featureShiftsMarkArray.value.push(false);

            if (
              moment(shift.date, "YYYY-MM-DD").isBefore(new Date(), "day") &&
              !pastShiftsMark.value
            ) {
              pastShiftsMark.value = true;
            }
          });
        }, { immediate: true });
      });



      const SuperRate = (shift) => {
        if (userRole === "pharmacy") {
          return shift.payRateSuper
            ? new Intl.NumberFormat("en-AU", {
                style: "currency",
                currency: "AUD",
              }).format(shift.payRateSuper)
            : "-";
        } else {
          if (shift.locum == null) {
            return "-";
          } else {
            return Intl.NumberFormat("en-AU", {
              style: "currency",
              currency: "AUD",
            }).format(shift.payRateSuper);
          }
        }
      };

      const distance = (job, shift) => {
        let result;
        const globalTravelCompensationValue =
          process.env.VUE_APP_TRAVEL_COMPENSATION;
        if (!shift.distance && !job.distance && !shift.historyDistance) {
          result = "-";
        } else {
          let distance;
          distance = shift.historyDistance ? shift.historyDistance : job.distance;
  
          if (job.settings.payingForTravel == 1) {
            if (distance * 2 > 50) {
              const result1 = (distance * 2 - 50) * globalTravelCompensationValue;
              result = new Intl.NumberFormat("en-AU", {
                style: "currency",
                currency: "AUD",
              }).format(result1);
            } else {
              result = "-";
            }
          } else if (job.settings.payingForTravel == 2) {
            result = new Intl.NumberFormat("en-AU", {
              style: "currency",
              currency: "AUD",
            }).format(distance * 2 * globalTravelCompensationValue);
          } else if (job.settings.payingForTravel == 3) {
            result = new Intl.NumberFormat("en-AU", {
              style: "currency",
              currency: "AUD",
            }).format(job.maxTravelCompensation);
          }
        }
        return result;
      };
  
      const formatHourlyRatePharmacy = () => {
        const rateArray = [];
  
        if (
          job.value.shifts.length === 1 &&
          job.value.shifts[0].payRateExecSuper
        ) {
          return new Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: "AUD",
          }).format(
            job.value.shifts[0].payRate - job.value.shifts[0].payRateSuper
          );
        }
  
        if (job.value.recommendedRatesString) {
          return job.value.recommendedRatesString;
        }
  
        if (job.value.minRate) {
          rateArray.push(job.value.minRate);
        }
        if (job.value.maxRate) {
          rateArray.push(job.value.maxRate);
        }
        if (job.value.weekendMaxRate) {
          rateArray.push(job.value.weekendMaxRate);
        }
        if (job.value.weekendMinRate) {
          rateArray.push(job.value.weekendMinRate);
        }
        if (job.value.saturdayMinRate) {
          rateArray.push(job.value.saturdayMinRate);
        }
        if (job.value.saturdayMaxRate) {
          rateArray.push(job.value.saturdayMaxRate);
        }
        if (job.value.sundayMinRate) {
          rateArray.push(job.value.sundayMinRate);
        }
        if (job.value.sundayMaxRate) {
          rateArray.push(job.value.sundayMaxRate);
        }
  
        rateArray.sort((a, b) => a - b);
        const firstEl = rateArray.shift();
        const lastEl = rateArray.pop();
        return (
          new Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: "AUD",
          }).format(firstEl) +
          " - " +
          new Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: "AUD",
          }).format(lastEl)
        );
      };

      const share = () => {
        moreBottomDropUp.value = false;
        const link = currentUrl + "job-preview/" + job.value.id;
        const el = document.createElement("textarea");
        el.value = link;
        el.setAttribute("readonly", "");
        el.style.position = "absolute";
        el.style.left = "-9999px";
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
        ElMessageBox.alert("Link to current job copied to clipboard", "Thanks", {
          type: "success ",
          showCancelButton: false,
          confirmButtonText: "Close",
          callback: () => {},
        });
      };
  
      const blockPharmacy = () => {
        moreBottomDropUp.value = false;
        const isPharmacyBlocked = job.value.blockedByLocum;
        const type = isPharmacyBlocked ? "unblock" : "block";
        let title = isPharmacyBlocked
          ? "Are you sure you want to unblock this pharmacy?"
          : "Are you sure you want to block this pharmacy?";
        let message = isPharmacyBlocked
          ? ""
          : "You will no longer see their shifts";
        ElMessageBox.confirm(message, title, {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        })
          .then(() => {
            $store
              .dispatch("BLOCK_PHARMACY", {
                pharmacyId: job.value.pharmacyId,
                type: type,
              })
              .then(() => {
                ElMessage({
                  type: "success",
                  message: `Pharmacy ${type}ed successfully`,
                });
                goBack();
              });
          })
          .catch(() => {});
      };

      const adminChangedTravelComp = (shift) => {
        if (shift.adminUpdatedTravelCompensation == true) {
          return true;
        } else {
          return false;
        }
      };
  
      const travelCompensationCount = (job, shift) => {
        
        let travelCompensation = calculateTravelCompensation(job, shift); // Call the original function
        // For pharmacy if shift is not taken by anyone then show job max travel compensation instead of travel compensation after accepted by locum
        if(shift.status === 0 && userRole === 'pharmacy') {
          return new Intl.NumberFormat("en-AU", {
              style: "currency",
              currency: "AUD",
            }).format(job.maxTravelCompensation);
        }
        //check if is not numeric travelCompensation retuirn -
        if (isNaN(parseFloat(travelCompensation.replace(/[^0-9.-]+/g, "")))) {
          return "-";
        }
        if (job.enableTravelAllowanceForFirstAndLastDay === 1) {
          let numericValue = parseFloat(travelCompensation.replace(/[^0-9.-]+/g, ""));  
          // from backend in pharmacy side we are getting the travel compensation as half of the value already after accepted by locum from adminUpdatedTravelCompensation
          let halfCompensation = numericValue ;  
          // Format back to currency using Intl.NumberFormat
          return new Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: "AUD",
          }).format(halfCompensation);
        }
  
        return travelCompensation; // Default behavior
      };
  
      const calculateTravelCompensation = (job, shift) => {
        if (!job.isInternalStaffOfThisPharmacy && job.isVisibileAsInternalLocum === false) {
          if (
            (shift.travelCompensation >= 0 &&
              shift.adminUpdatedTravelCompensation == true) ||
            (shift.travelCompensation === 0 &&
              shift.adminUpdatedTravelCompensation == true)
          ) {
            const convertedTravelRate = formatCurrency(shift.travelCompensation);
            return convertedTravelRate;
          }else if(shift.travelCompensation >= 0 ){
            const convertedTravelRate = formatCurrency(shift.travelCompensation);
            return convertedTravelRate;
          } else {
            if (
              job.settings.payingForTravel === 0 &&
              shift.adminUpdatedTravelCompensation == false
            ) {
              return "-";
            }
          }
  
          if (
            job.settings.payingForTravel === 3 &&
            job.maxTravelCompensation !== 0
          ) {
            let travelCompensation;
  
            //admin may change the travel compensation for the job via job menu in the admin panel
            //the changed travel compensation only reflects on the shifts that has not been booked
            //so to keep track of previous travel compensations, we store the travel compensation in the shift table as well naming the column as job_max_travel_compensation
            //job_max_travel_compensation in the shift table is updated when admin updates the travel compensation for the job
            //where the shifts job_max_travel_compensation that has been booked is updated with previous travel compensation and the shifts that has not been booked is updated with the new travel compensation
            let maxTravelCompensation =
              shift.jobMaxTravelCompensation && shift.userId
                ? shift.jobMaxTravelCompensation
                : job.maxTravelCompensation;
            const globalTravelCompensationValue =
              process.env.VUE_APP_TRAVEL_COMPENSATION;
              let jobDistance;
              if (shift.distance) {
              jobDistance = shift.distance;
            } else {
              jobDistance = shift.historyDistance ? shift.historyDistance : job.distance;
            }
  
            if (jobDistance) {
              let distance = jobDistance;
              travelCompensation = distance * 2 * globalTravelCompensationValue;
              if (travelCompensation > maxTravelCompensation) {
                const convertedTravelRate = formatCurrency(maxTravelCompensation);
                return convertedTravelRate;
              } else {
                travelCompensation = new Intl.NumberFormat("en-AU", {
                  style: "currency",
                  currency: "AUD",
                }).format(distance * 2 * globalTravelCompensationValue);
                return travelCompensation;
              }
            } else {
              const convertedTravelRate = formatCurrency(maxTravelCompensation);
              return convertedTravelRate;
            }
          } else {
            const convertedTravelRate = formatCurrency(+shift.travelCompensation);
            return convertedTravelRate;
          }
        } else {
          return "-";
        }
  
      };

      function formatDate(date) {
        return $moment(date, "YYYY-MM-DD").format("dddd, D MMMM");
      }
  
      const {
        checkFormValidation,
        setFormValidation,
        setFormRefs,
        formsData,
        formsRefs,
      } = formHooks(formsDataArray);
      return {
        travelCompensationCount,
        formsData,
        checkFormValidation,
        setFormValidation,
        goToJobCalendar,
        goBack,
        goNext,
        submit,
        job,
        shifts,
        shiftsList,
        isLoadingShifts,
        isLoadingMoreShifts,
        hasMoreShifts,
        checkJobDateStart,
        routeName,
        userRole,
        featureShiftsMarkArray,
        pastShiftsMark,
        breakTimeFormat,
        userInfoModalOpen,
        userInfoModal,
        shiftEditModal,
        ApplicationsModal,
        bottomDropUp,
        actions,
        formatHourlyRate,
        distance,
        newJobData,
        formatHourlyRatePharmacy,
        share,
        adminChangedTravelComp,
        userData,
        handleClick,
        agencyInfoModal,
        agnecyInfoModalOpen,
        selectedApplicants,
        isSelected,
        handleCheckboxChange,
        activeCollapse,
        isValidSelect,
        isBlockShift,
        BlockApplicationsModal,
        goToJobApplicants,
        formatCurrency,
        blockPharmacy,
        moreBottomDropUp,
        SuperRate,
        showActions,
        isAustralia,
        message,
        dialog,
        getCancellationReason,
        bulkShiftListToShow,
        formatDate,
        removeButtonDisabled,
        BlockShiftModal,
        calculateTravelCompensation,
        distanceInMiles,
        cleanReactiveObject,
        loadMoreShifts
      };
    },
  };
  </script>
  
